<p-card>
  <div class="row">
    <div class="col-12">
      <div>
        <h1 class="mb-3">Catálogo de canales</h1>
        <p class="mb-3 text-color-secondary">
          Orígenes de captación de clientes (Omnicanal). Administra las claves de canal, su categoría y el rol que las origina.
        </p>
      </div>
    </div>
    <p-confirmDialog></p-confirmDialog>
  </div>

  <div class="row">
    <div class="col-12">
      <app-main-table [apiService]="apiService" [columns]="columns" [actions]="actions" [additionalMainActions]="additionalMainActions" singleEntityName="canal" pluralEntityName="canales" (onAction)="onAction($event)" (onMainAction)="onMainAction($event)"></app-main-table>
    </div>
  </div>

  <app-channel-source-form [(visible)]="formVisible" [editing]="editing" (saved)="onSaved()"></app-channel-source-form>
</p-card>
